import { createContext, useEffect, useState } from "react";
import axios from "axios";

// const token =   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhZG1pbklkIjoiNjc5YTdiOGE3MzUwYmRkMDZmODNiYTA2IiwiaWF0IjoxNzQwMzcyNzkzLCJleHAiOjE3NDA5Nzc1OTN9.pBeS4ecJLiGTzZe12e0A9SKqxSewzmIJUlBZ3o_IsO0"
const token = localStorage.getItem("adminToken")
console.log("TOKEN : " , token)
export const ApiContext = createContext()
const ApiProvider = ({ children }) => {
  const [partners, setPartners] = useState([]);
  const [partner, setPartner] = useState({});

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const res = await axios.get(
          // "https://wavetechservices.in/api/partner/partnersprofile",
          "https://wavetechservices.in/api/admin/partners",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // setPartners(res.data.admins);
        // console.log("RESPONSE PARTNERS : " , res.data)
        setPartners(res.data.partners);
        // console.log(res, "response")
      } catch (err) {
        console.log(err, "error");
      }
    };
    fetchPartners();
  }, []);
  console.log("apipartners : " , partners)

  return (
    <ApiContext.Provider
      value={{
        partners,
        setPartners,
        partner,
        setPartner,
      }}
    >
      {children}
    </ApiContext.Provider>
  );
};

export default ApiProvider;